import React, {useState, FC} from 'react'
import {useHistory, useLocation} from 'react-router';
import dayjs from "dayjs";
import styles from './onboarding.module.scss';
import {
    Page,
    Container,
    ButtonContainer,
    ContinueButton
} from "./Onboarding_DO.styles";
import HeaderStatusBar from "../../../components/HeaderStatusBar";
import RadioButton from 'components/RadioButton/RadioButton';
import {TutorialPopup} from '../TutorialPopup';
import {completeRegistrationDoProps} from "../SignUp1_DO/SignUp1_DO";


// @ts-ignore
const TempStars: any = window.TempStars;


const Onboarding_DO = () => {
    const history = useHistory();

    const { state } = useLocation<completeRegistrationDoProps>();
    const { practiceName, country }  = state;

    const [screenError, setScreenError] = useState(false);
    const [selected, setSelected] = useState<string | null>(null);
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    
    const OPTIONS = {
        TEMP: "0",
        HIRE: "1"
    }
    
    const handleClick = (selectedItem: string) => {
        setSelected(selectedItem);
    };

    const onOpenPopup = () => {
        setIsOpenPopup(true);
    }

    const onContinue = () => {
        if (selected === OPTIONS.TEMP) {
            TempStars.Analytics.track('Select-Route', {
                route_selected: 'Find-Temp'
            });
            return history.push({ pathname: 'postJob' }, {date: dayjs()})
        } else if (selected === OPTIONS.HIRE) {
            TempStars.Analytics.track('Select-Route', {
                route_selected: 'Hire-Team'
            });
            return history.push({pathname: 'jobBoard'}, {openPopup: true})
        } else {
            TempStars.Analytics.track('Select-Route', {
                route_selected: 'Skip-Calendar'
            });
            setIsOpenPopup(false);
            return TempStars.App.gotoStartingPage()
        }    
    }

    return (
        <Page>
            <HeaderStatusBar />
                    <Container>
                        <div className={styles.practiceNameSubtitle}>
                            {practiceName}
                        </div>
                        <div className={styles.pageTitle}>
                            What do you want to do first?
                        </div>
                        <div className={styles.pageDescription}>
                            <p>It's great to have you!  We just sent you a Welcome Email with some resources to let you hit the ground running.</p> 
                            <p>Make sure you set "help@tempstars.com" as safe so our messages don't end up in your spam/junk.</p>
                        </div>

                        <div className="screenError">
                            {screenError ? 'Please fix the errors below' : undefined}
                        </div>
                    <div className={styles.tempWrapper}>
                        <div className={styles.radioGroup}>
                        <RadioButton 
                                isActive={selected === OPTIONS.TEMP}
                                handleClick={() => handleClick(OPTIONS.TEMP)}
                                item={OPTIONS.TEMP}
                            />
                            <div className={styles.optionTitle}>
                                I need to find a temp!
                            </div>
                        </div>
                        <div className={'inset'}>
                            <p className={styles.optionText}>
                                <ul>
                                    <li>Access our fast, easy dental temping service.</li>
                                    <li>Built by a dentist, for dental professionals - over 95,000 temping shifts completed.</li>
                                    <li>Over 10,000 dental offices like yours trust TempStars for their Dental Temping.</li>
                                    <li>Only {country ? '$38' : '$57 +hst'} flat fee temping (no mark-ups or subscriptions), and we don't charge for permanent hires!</li>
                                </ul>
                            </p>
                        </div>
                    </div>

                    <div className={styles.hireWrapper}>
                        <div className={styles.radioGroup}>
                        <RadioButton 
                                isActive={selected === OPTIONS.HIRE}
                                handleClick={() => handleClick(OPTIONS.HIRE)}
                                item={OPTIONS.HIRE}
                            />
                            <div className={styles.optionTitle}>
                                I need to hire someone to my team
                            </div>
                        </div>
                        <div className={'inset'}>
                            <p className={styles.optionText}>
                                <ul>
                                    <li>TempStars' Job Board is a game-changer.  Free to post, and free to hire....seriously.</li>
                                    <li>Our Recommendation Engine helps you find the best candidates so you can build your team and grow your practice.</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <ButtonContainer>
                    <ContinueButton
                        variant="outlined"
                        size="large"
                        color={"primary"}
                        onClick={onOpenPopup}
                    >
                        Skip for now
                    </ContinueButton> 
                    <ContinueButton
                        variant="contained"
                        size="large"
                        color={"primary"}
                        onClick={!selected ? onOpenPopup : onContinue}
                    >
                        Let's do this!
                    </ContinueButton>    
                </ButtonContainer>
                <TutorialPopup
                        isOpen={isOpenPopup}
                        onContinue={onContinue}
                        onClose={() => setIsOpenPopup(false)}
                        title={"Great! Here's an overview"}
                        listItems={[
                            "Tap a date to post a temping shift for that date", 
                            "Tap 'Hire Staff' to access the Job Board to post an opening for a permanent/contract position", 
                            "Remember, we don't charge for permanent hires, so if you're looking to hire - you're welcome to post temping shifts and if you find a good fit, you can just hire them!"
                        ]}
                />
            </Container>
        </Page>
    )
}

export default Onboarding_DO;